import axios from 'axios'

export default {
  index (query: any = null, is_paginate = true) {
    return new Promise((resolve, reject) => {
      let params = { pagination: is_paginate }
      params = { ...query, ...params }
      axios
        .get('custom-permission-details', {
          params: params
        }).then((response) => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  store (payload: any) {
    return axios
      .post('custom-permission-details', payload)
      .then((response) => {
        return response.data
      }).catch((error) => {
        throw error.response
      })
  },
  show (id: any) {
    return axios
      .get('custom-permission-details/' + id)
      .then((response) => {
        return response.data
      }).catch((error) => {
        throw error.response
      })
  },
  update (id: any, payload: any) {
    return axios
      .put('custom-permission-details/' + id, payload)
      .then((response) => {
        return response.data
      }).catch((error) => {
        throw error.response
      })
  },
  destroy (id: any) {
    return axios
      .delete('custom-permission-details/' + id)
      .then((response) => {
        return response.data
      }).catch((error) => {
        throw error.response
      })
  }
}
